import React from 'react';
import { useStopwatch } from 'react-timer-hook';
import TimerStyled from './TimerStyled';
import { Button } from 'semantic-ui-react';

/* `offsetTimestamp` must be a Date: react-timer-hook v4 calls .getTime() on it,
   so a raw epoch number throws "e.getTime is not a function". Starting a round
   hid that - its startDateTime is absent, so the expression came out NaN and the
   hook skipped the call - but resuming one passes a real number and every
   theme's header crashed. Kept as a Date at all five call sites. */
const Stopwatch =({ offsetTimestamp, theme, onPauseChanged, isAutoStart }) => {
    const { seconds, minutes, hours, days, isRunning, start, pause } = useStopwatch({ autoStart: isAutoStart, offsetTimestamp });

    const pauseClick = () => {
        if (isRunning) {
            pause();
            if (onPauseChanged)
                onPauseChanged(true);
        }
        else {
            start();
            if (onPauseChanged)
                onPauseChanged(false);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'row', gap: 10 }} >
            <TimerStyled type='STOPWATCH' theme={theme} seconds={seconds} minutes={minutes} hours={hours} days={days} />
            <div>
                <Button icon={isRunning ? 'pause' : 'play'} size='tiny' circular style={{ margin: '5px' }} onClick={pauseClick} />
            </div>
        </div>
    );
};

export default Stopwatch;

